import {
  ProgressOverviewPageConfig,
  ProgressReportByProcessPageConfig,
  ProgressReportByTeamPageConfig,
  VersionReportVersionPageEntity,
} from './index'

export type PageValidationError = {
  field: string
  message: string
}

export const validatePageEntity = (
  page: Pick<
    VersionReportVersionPageEntity,
    'pageTitle' | 'pageType' | 'config'
  >
): PageValidationError[] => {
  const errors: PageValidationError[] = []

  if (!page.pageTitle || !page.pageTitle.trim()) {
    errors.push({
      field: 'pageTitle',
      message: 'ページタイトルを入力してください',
    })
  }

  switch (page.pageType) {
    case 'PROGRESS_OVERVIEW': {
      const config = page.config as ProgressOverviewPageConfig
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: '対象工程が選択されていません',
        })
      }
      break
    }
    case 'PROGRESS_REPORT_BY_PROCESS': {
      const config = page.config as ProgressReportByProcessPageConfig
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: '集計対象の工程が選択されていません',
        })
      }
      break
    }
    case 'PROGRESS_REPORT_BY_TEAM': {
      const config = page.config as ProgressReportByTeamPageConfig
      if (!config.rootUuid) {
        errors.push({
          field: 'rootUuid',
          message: '集計基準となる工程が選択されていません',
        })
      }
      if (!config.tableRows || config.tableRows.length === 0) {
        errors.push({
          field: 'tableRows',
          message: '集計対象のチームが選択されていません',
        })
      }
      break
    }
    default:
      errors.push({
        field: 'pageType',
        message: '不明なページタイプです',
      })
  }

  return errors
}
